const slideSliceHasContent = (slice: any) => {
  if(slice?.slice_type === `video_slide`) return Boolean(slice?.primary?.embed?.html)
  else return Boolean(slice?.primary?.image?.gatsbyImageData)
}

export default slideSliceHasContent
export { slideSliceHasContent }